export interface PaymentType {
  id: number;
  aadeCode: PAYMENT_METHOD_AADE_CODE;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum PAYMENT_METHOD_AADE_CODE {
  'DOMESTIC_ACCOUNT' = '1', // Επαγ. Λογαριασμός Πληρωμών Ημεδαπής
  'FOREIGN_ACCOUNT' = '2', // Επαγ. Λογαριασμός Πληρωμών Αλλοδαπής
  'CASH' = '3', // Μετρητά
  'CHECK' = '4', // Επιταγή
  'CREDIT' = '5', // Επί Πιστώσει
  'WEB_BANKING' = '6', // Web banking
  'POS' = '7', // POS / e-POS
  'IRIS' = '8', // Άμεσες πληρωμές IRIS
}

/**
 * We keep POS here in order to be able to render the new customer subtotal when the doc
 * is not posted yet
 */
export const UNVERIFIED_PAYMENTS = [PAYMENT_METHOD_AADE_CODE.CREDIT, PAYMENT_METHOD_AADE_CODE.POS];
